//export class ClonePhone {
//    static readonly type = '[Contract.Phone] Clone Phone';
//    constructor(public phoneID: number, public copies: number = 1) { }
//}

export class DeletePhone {
  static readonly type = '[Contract.Phone] Delete Phone';
  constructor(public entityID: string, public phoneID: number) {}
}

export class RestorePhone {
  static readonly type = '[Contract.Phone] Restore Phone';
  constructor(public phoneID: number) {}
}

export class ClonePhone {
  static readonly type = '[Contract.Phone] Clone Phone';
  constructor(public entityID: string, public phoneID: number) {}
}

export class AddPhone {
  static readonly type = '[Contract.Phone] Add Phone';
  constructor(public entityID: string, public phone: any) {}
}

export class UpdatePhone {
  static readonly type = '[Contract.Phone] Update Phone';
  constructor(public entityID: string, public phone: any) {}
}

export class SetThirdPartyPhones {
  static readonly type = '[Contract.Phone] Set Third Party Phones';
  constructor(public phones: any) {}
}

export class ClearThirdPartyPhone {
  static readonly type = '[Contract.Phone] Clear Third Party Phone';
  constructor(public phoneID: number) {}
}
